//libs
import { useState } from 'react';
import classNames from 'classnames';

//components
import Arrow from '../images/arrow.svg';
import ArrowYel from '../images/arrow-yel.svg';

//types
import { ICityItemProps } from '../types/ICityItemProps';


 const CityItem = ({
    city,
    isActive,
    setCityHandler,
}: ICityItemProps) => {
    const [highlight, setHighlight] = useState(false);
    const classes = classNames(
        'cities-filter-list__item', 
        {
            'cities-filter-list__item--active': isActive,
        }
    );

    return (
        <div
            className={classes}
            onClick={() => setCityHandler()}
            onMouseEnter={() => setHighlight(true)}
            onMouseLeave={() => setHighlight(false)}
        >
            <img src={(highlight || isActive) ? ArrowYel : Arrow} alt="arrow"/>
            {city}
        </div>
    );
};


export default CityItem;